export const match = {
  id: 12536,
  name:
    'Temporada 2019/2020 - LaLiga Santander - CD Leganés - FC Barcelona - 14',
  slug: 'temporada-2019-2020-laliga-santander-cd-leganes-fc-barcelona-14',
  date: '2019-11-23T12:00:00+00:00',
  time: '2019-11-23T12:00:00+00:00',
  hashtag: 'LeganésBarça',
  competition: {
    id: 1,
    name: 'LaLiga Santander',
    slug: 'primera-division',
    main: true,
    opta_id: '23',
    old_hub_id: 1,
  },
  home_score: 1,
  away_score: 2,
  status: 'FullTime',
  attempt: 9465,
  attempt_official: true,
  home_team: {
    id: 54,
    slug: 'cd-leganes',
    name: 'Club Deportivo Leganés SAD',
    nickname: 'CD Leganés',
    boundname: 'CD Leganés',
    shortname: 'LEG',
    color: '#1476c4',
    color_secondary: '#ffffff',
    shirt_style: 'mono',
    foundation: '1928-06-23T00:00:00+00:00',
    web: 'http://www.deportivoleganes.com/',
    shield: {
      id: 225,
      name: 'Escudo LEG',
      caption: 'Escudo LEG',
      url: 'https://assets.laliga.com/assets/2019/06/07/xlarge/leganes.png',
      resizes: {
        xsmall:
          'https://assets.laliga.com/assets/2019/06/07/xsmall/leganes.png',
        small: 'https://assets.laliga.com/assets/2019/06/07/small/leganes.png',
        medium:
          'https://assets.laliga.com/assets/2019/06/07/medium/leganes.png',
        large: 'https://assets.laliga.com/assets/2019/06/07/large/leganes.png',
        xlarge:
          'https://assets.laliga.com/assets/2019/06/07/xlarge/leganes.png',
      },
    },
    competitions: [],
    opta_id: 't957',
    old_hub_id: 54,
    trainer: {
      id: 18499,
      position: {
        id: 5,
        name: 'Entrenador',
        slug: 'entrenador',
        plural_name: 'Entrenador',
        female_name: 'Entrenadora',
        female_plural_name: 'Entrenador',
      },
      person: {
        id: 411,
        name: 'Ernesto Valverde Tejedor',
        nickname: 'Ernesto Valverde',
        firstname: 'Ernesto',
        lastname: 'Valverde Tejedor',
        gender: 'male',
        date_of_birth: '1964-02-09T00:00:00+00:00',
        international: false,
        country: {
          id: 'ES',
        },
        slug: 'valverde',
      },
      role: {
        name: 'Entrenador',
        female_name: 'Entrenadora',
        slug: 'entrenador',
      },
    },
    squad: [
      {
        id: 18476,
        shirt_number: 1,
        position: {
          id: 1,
          name: 'Portero',
          slug: 'portero',
          plural_name: 'Porteros',
          female_name: 'Portera',
          female_plural_name: 'Porteras',
        },
        person: {
          id: 1339,
          name: 'Marc-André Ter Stegen',
          nickname: 'Ter Stegen',
          firstname: 'Marc-André',
          lastname: 'Ter Stegen',
          gender: 'male',
          date_of_birth: '1992-04-30T00:00:00+00:00',
          place_of_birth: 'Mönchengladbach',
          weight: 85,
          height: 187,
          international: true,
          country: {
            id: 'DE',
          },
          slug: 'ter-stegen',
        },
        role: {
          titular: true,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18478,
        shirt_number: 2,
        position: {
          id: 2,
          name: 'Defensa',
          slug: 'defensa',
          plural_name: 'Defensas',
          female_name: 'Defensa',
          female_plural_name: 'Defensas',
        },
        person: {
          id: 2658,
          name: 'Nelson Cabral Semedo',
          nickname: 'N. Semedo',
          firstname: 'Nelson',
          lastname: 'Cabral Semedo',
          gender: 'male',
          date_of_birth: '1993-11-16T00:00:00+00:00',
          place_of_birth: 'Lisboa',
          weight: 67,
          height: 177,
          international: true,
          country: {
            id: 'PT',
          },
          slug: 'n-semedo',
        },
        role: {
          titular: false,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18479,
        shirt_number: 3,
        position: {
          id: 2,
          name: 'Defensa',
          slug: 'defensa',
          plural_name: 'Defensas',
          female_name: 'Defensa',
          female_plural_name: 'Defensas',
        },
        person: {
          id: 5,
          name: 'Gerard Piqué Bernabéu',
          nickname: 'Piqué',
          firstname: 'Gerard',
          lastname: 'Piqué Bernabéu',
          gender: 'male',
          date_of_birth: '1987-02-02T00:00:00+00:00',
          place_of_birth: 'Barcelona',
          weight: 85,
          height: 194,
          international: true,
          country: {
            id: 'ES',
          },
          slug: 'pique',
        },
        role: {
          titular: true,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18486,
        shirt_number: 4,
        position: {
          id: 3,
          name: 'Centrocampista',
          slug: 'centrocampista',
          plural_name: 'Centrocampistas',
          female_name: 'Centrocampista',
          female_plural_name: 'Centrocampistas',
        },
        person: {
          id: 137,
          name: 'Ivan Rakitić',
          nickname: 'I. Rakitic',
          firstname: 'Ivan',
          lastname: 'Rakitić',
          gender: 'male',
          date_of_birth: '1988-03-10T00:00:00+00:00',
          place_of_birth: 'Rheinfelden',
          weight: 78,
          height: 184,
          international: true,
          country: {
            id: 'CH',
          },
          slug: 'i-rakitic',
        },
        role: {
          titular: true,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18487,
        shirt_number: 5,
        position: {
          id: 3,
          name: 'Centrocampista',
          slug: 'centrocampista',
          plural_name: 'Centrocampistas',
          female_name: 'Centrocampista',
          female_plural_name: 'Centrocampistas',
        },
        person: {
          id: 16,
          name: 'Sergio Busquets Burgos',
          nickname: 'Sergio',
          firstname: 'Sergio',
          lastname: 'Busquets Burgos',
          gender: 'male',
          date_of_birth: '1988-07-16T00:00:00+00:00',
          place_of_birth: 'Sabadell',
          weight: 76,
          height: 189,
          international: true,
          country: {
            id: 'ES',
          },
          slug: 'sergio',
        },
        role: {
          titular: true,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18480,
        shirt_number: 6,
        position: {
          id: 2,
          name: 'Defensa',
          slug: 'defensa',
          plural_name: 'Defensas',
          female_name: 'Defensa',
          female_plural_name: 'Defensas',
        },
        person: {
          id: 9683,
          name: 'Jean-Clair Todibo',
          nickname: 'Todibo',
          firstname: 'Jean-Clair',
          lastname: 'Todibo',
          gender: 'male',
          date_of_birth: '1999-12-30T00:00:00+00:00',
          place_of_birth: 'Cayenne',
          weight: 81,
          height: 190,
          international: false,
          country: {
            id: 'GF',
          },
          slug: 'todibo',
        },
        role: {
          titular: false,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18489,
        shirt_number: 8,
        position: {
          id: 3,
          name: 'Centrocampista',
          slug: 'centrocampista',
          plural_name: 'Centrocampistas',
          female_name: 'Centrocampista',
          female_plural_name: 'Centrocampistas',
        },
        person: {
          id: 8586,
          name: 'Arthur Henrique Ramos de',
          nickname: 'Arthur',
          firstname: 'Arthur Henrique',
          lastname: 'Ramos de',
          gender: 'male',
          date_of_birth: '1996-08-12T00:00:00+00:00',
          place_of_birth: 'Goiânia',
          weight: 73,
          height: 171,
          international: false,
          country: {
            id: 'BR',
          },
          slug: 'arthur',
        },
        role: {
          titular: true,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18493,
        shirt_number: 9,
        position: {
          id: 4,
          name: 'Delantero',
          slug: 'delantero',
          plural_name: 'Delanteros',
          female_name: 'Delantera',
          female_plural_name: 'Delanteras',
        },
        person: {
          id: 1460,
          name: 'Luis Alberto Suárez Díaz',
          nickname: 'Suárez',
          firstname: 'Luis Alberto',
          lastname: 'Suárez Díaz',
          gender: 'male',
          date_of_birth: '1987-01-24T00:00:00+00:00',
          place_of_birth: 'Salto',
          weight: 86,
          height: 182,
          international: true,
          country: {
            id: 'UY',
          },
          slug: 'suarez',
        },
        role: {
          titular: true,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18494,
        shirt_number: 10,
        position: {
          id: 4,
          name: 'Delantero',
          slug: 'delantero',
          plural_name: 'Delanteros',
          female_name: 'Delantera',
          female_plural_name: 'Delanteras',
        },
        person: {
          id: 23,
          name: 'Lionel Andrés Messi',
          nickname: 'Messi',
          firstname: 'Lionel',
          lastname: 'Andrés Messi',
          gender: 'male',
          date_of_birth: '1987-06-24T00:00:00+00:00',
          place_of_birth: 'Rosario',
          weight: 72,
          height: 170,
          international: true,
          country: {
            id: 'AR',
          },
          slug: 'messi',
        },
        role: {
          titular: true,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18475,
        shirt_number: 13,
        position: {
          id: 1,
          name: 'Portero',
          slug: 'portero',
          plural_name: 'Porteros',
          female_name: 'Portera',
          female_plural_name: 'Porteras',
        },
        person: {
          id: 2681,
          name: 'Norberto Murara Neto',
          nickname: 'Neto',
          firstname: 'Norberto',
          lastname: 'Murara Neto',
          gender: 'male',
          date_of_birth: '1989-07-19T00:00:00+00:00',
          place_of_birth: 'Araxá',
          weight: 84,
          height: 190,
          international: true,
          country: {
            id: 'BR',
          },
          slug: 'neto',
        },
        role: {
          titular: false,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18481,
        shirt_number: 15,
        position: {
          id: 2,
          name: 'Defensa',
          slug: 'defensa',
          plural_name: 'Defensas',
          female_name: 'Defensa',
          female_plural_name: 'Defensas',
        },
        person: {
          id: 5861,
          name: 'Clement Nicolas Laurent Lenglet',
          nickname: 'Lenglet',
          firstname: 'Clement Nicolas',
          lastname: 'Laurent Lenglet',
          gender: 'male',
          date_of_birth: '1995-06-17T00:00:00+00:00',
          place_of_birth: 'Beauvais',
          weight: 81,
          height: 186,
          international: false,
          country: {
            id: 'FR',
          },
          slug: 'lenglet',
        },
        role: {
          titular: true,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 19775,
        shirt_number: 16,
        position: {
          id: 2,
          name: 'Defensa',
          slug: 'defensa',
          plural_name: 'Defensas',
          female_name: 'Defensa',
          female_plural_name: 'Defensas',
        },
        person: {
          id: 8436,
          name: 'Moussa Wagué',
          nickname: 'Moussa Wague',
          firstname: 'Moussa',
          lastname: 'Wagué',
          gender: 'male',
          date_of_birth: '1998-10-04T00:00:00+00:00',
          place_of_birth: 'Bignona',
          weight: 70,
          height: 177,
          international: true,
          country: {
            id: 'SN',
          },
          slug: 'moussa-wague',
        },
        role: {
          titular: false,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 19473,
        shirt_number: 17,
        position: {
          id: 3,
          name: 'Centrocampista',
          slug: 'centrocampista',
          plural_name: 'Centrocampistas',
          female_name: 'Centrocampista',
          female_plural_name: 'Centrocampistas',
        },
        person: {
          id: 699,
          name: 'Antoine Griezmann',
          nickname: 'Griezmann',
          firstname: 'Antoine',
          lastname: 'Griezmann',
          gender: 'male',
          date_of_birth: '1991-03-21T00:00:00+00:00',
          place_of_birth: 'Mâcon',
          weight: 73,
          height: 176,
          international: true,
          country: {
            id: 'FR',
          },
          slug: 'griezmann',
        },
        role: {
          titular: true,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18482,
        shirt_number: 18,
        position: {
          id: 2,
          name: 'Defensa',
          slug: 'defensa',
          plural_name: 'Defensas',
          female_name: 'Defensa',
          female_plural_name: 'Defensas',
        },
        person: {
          id: 8,
          name: 'Jordi Alba Ramos',
          nickname: 'Jordi Alba',
          firstname: 'Jordi',
          lastname: 'Alba Ramos',
          gender: 'male',
          date_of_birth: '1989-03-21T00:00:00+00:00',
          place_of_birth: 'Hospitalet de Llobregat',
          weight: 68,
          height: 170,
          international: true,
          country: {
            id: 'ES',
          },
          slug: 'jordi-alba',
        },
        role: {
          titular: true,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18483,
        shirt_number: 20,
        position: {
          id: 2,
          name: 'Defensa',
          slug: 'defensa',
          plural_name: 'Defensas',
          female_name: 'Defensa',
          female_plural_name: 'Defensas',
        },
        person: {
          id: 21,
          name: 'Sergi Roberto Carnicer',
          nickname: 'S. Roberto',
          firstname: 'Sergi',
          lastname: 'Roberto Carnicer',
          gender: 'male',
          date_of_birth: '1992-02-07T00:00:00+00:00',
          place_of_birth: 'Reus',
          weight: 68,
          height: 178,
          international: true,
          country: {
            id: 'ES',
          },
          slug: 's-roberto',
        },
        role: {
          titular: true,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18485,
        shirt_number: 21,
        position: {
          id: 3,
          name: 'Centrocampista',
          slug: 'centrocampista',
          plural_name: 'Centrocampistas',
          female_name: 'Centrocampista',
          female_plural_name: 'Centrocampistas',
        },
        person: {
          id: 5629,
          name: 'Frenkie de Jong',
          nickname: 'De Jong',
          firstname: 'Frenkie',
          lastname: 'de Jong',
          gender: 'male',
          date_of_birth: '1997-05-12T00:00:00+00:00',
          place_of_birth: 'Arkel',
          weight: 74,
          height: 180,
          international: false,
          country: {
            id: 'NL',
          },
          slug: 'de-jong',
        },
        role: {
          titular: false,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18492,
        shirt_number: 22,
        position: {
          id: 3,
          name: 'Centrocampista',
          slug: 'centrocampista',
          plural_name: 'Centrocampistas',
          female_name: 'Centrocampista',
          female_plural_name: 'Centrocampistas',
        },
        person: {
          id: 3705,
          name: 'Arturo Vidal',
          nickname: 'Vidal',
          firstname: 'Arturo',
          lastname: 'Vidal',
          gender: 'male',
          date_of_birth: '1987-05-22T00:00:00+00:00',
          place_of_birth: 'Santiago de Chile',
          weight: 75,
          height: 180,
          international: true,
          country: {
            id: 'CL',
          },
          slug: 'vidal-1',
        },
        role: {
          titular: false,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18484,
        shirt_number: 23,
        position: {
          id: 2,
          name: 'Defensa',
          slug: 'defensa',
          plural_name: 'Defensas',
          female_name: 'Defensa',
          female_plural_name: 'Defensas',
        },
        person: {
          id: 2306,
          name: 'Samuel Umtiti',
          nickname: 'Umtiti',
          firstname: 'Samuel',
          lastname: 'Umtiti',
          gender: 'male',
          date_of_birth: '1993-11-14T00:00:00+00:00',
          place_of_birth: 'Yaoundé',
          weight: 75,
          height: 182,
          international: true,
          country: {
            id: 'CM',
          },
          slug: 'umtiti',
        },
        role: {
          titular: false,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 19613,
        shirt_number: 26,
        position: {
          id: 1,
          name: 'Portero',
          slug: 'portero',
          plural_name: 'Porteros',
          female_name: 'Portera',
          female_plural_name: 'Porteras',
        },
        person: {
          id: 9409,
          name: 'Ignacio Peña',
          nickname: 'Iñaki',
          firstname: 'Ignacio',
          lastname: 'Peña',
          gender: 'male',
          date_of_birth: '1999-03-02T00:00:00+00:00',
          place_of_birth: 'Alicante',
          weight: 78,
          height: 184,
          international: false,
          country: {
            id: 'ES',
          },
          slug: 'inaki-1',
        },
        role: {
          titular: false,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 20046,
        shirt_number: 31,
        position: {
          id: 4,
          name: 'Delantero',
          slug: 'delantero',
          plural_name: 'Delanteros',
          female_name: 'Delantera',
          female_plural_name: 'Delanteras',
        },
        person: {
          id: 12722,
          name: 'Anssumane Fati',
          nickname: 'Ansu Fati',
          firstname: 'Anssumane',
          lastname: 'Fati',
          gender: 'male',
          date_of_birth: '2002-10-31T00:00:00+00:00',
          place_of_birth: 'Bissau',
          weight: 66,
          height: 178,
          international: false,
          country: {
            id: 'GW',
          },
          slug: 'ansu-fati',
        },
        role: {
          titular: false,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
    ],
  },
  away_team: {
    id: 4,
    slug: 'fc-barcelona',
    name: 'Fútbol Club Barcelona',
    nickname: 'FC Barcelona',
    boundname: 'FC Barcelona',
    shortname: 'BAR',
    foundation: '1899-11-29T00:00:00+00:00',
    web: 'http://www.fcbarcelona.es',
    shield: {
      id: 127,
      name: 'Escudo BAR',
      caption: 'Escudo BAR',
      url: 'https://assets.laliga.com/assets/2019/06/07/xlarge/barcelona.png',
      resizes: {
        xsmall:
          'https://assets.laliga.com/assets/2019/06/07/xsmall/barcelona.png',
        small:
          'https://assets.laliga.com/assets/2019/06/07/small/barcelona.png',
        medium:
          'https://assets.laliga.com/assets/2019/06/07/medium/barcelona.png',
        large:
          'https://assets.laliga.com/assets/2019/06/07/large/barcelona.png',
        xlarge:
          'https://assets.laliga.com/assets/2019/06/07/xlarge/barcelona.png',
      },
    },
    competitions: [],
    opta_id: 't178',
    old_hub_id: 4,
    trainer: {
      id: 18499,
      position: {
        id: 5,
        name: 'Entrenador',
        slug: 'entrenador',
        plural_name: 'Entrenador',
        female_name: 'Entrenadora',
        female_plural_name: 'Entrenador',
      },
      person: {
        id: 411,
        name: 'Ernesto Valverde Tejedor',
        nickname: 'Ernesto Valverde',
        firstname: 'Ernesto',
        lastname: 'Valverde Tejedor',
        gender: 'male',
        date_of_birth: '1964-02-09T00:00:00+00:00',
        international: false,
        country: {
          id: 'ES',
        },
        slug: 'valverde',
      },
      role: {
        name: 'Entrenador',
        female_name: 'Entrenadora',
        slug: 'entrenador',
      },
    },
    squad: [
      {
        id: 18476,
        shirt_number: 1,
        position: {
          id: 1,
          name: 'Portero',
          slug: 'portero',
          plural_name: 'Porteros',
          female_name: 'Portera',
          female_plural_name: 'Porteras',
        },
        person: {
          id: 1339,
          name: 'Marc-André Ter Stegen',
          nickname: 'Ter Stegen',
          firstname: 'Marc-André',
          lastname: 'Ter Stegen',
          gender: 'male',
          date_of_birth: '1992-04-30T00:00:00+00:00',
          place_of_birth: 'Mönchengladbach',
          weight: 85,
          height: 187,
          international: true,
          country: {
            id: 'DE',
          },
          slug: 'ter-stegen',
        },
        role: {
          titular: true,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18478,
        shirt_number: 2,
        position: {
          id: 2,
          name: 'Defensa',
          slug: 'defensa',
          plural_name: 'Defensas',
          female_name: 'Defensa',
          female_plural_name: 'Defensas',
        },
        person: {
          id: 2658,
          name: 'Nelson Cabral Semedo',
          nickname: 'N. Semedo',
          firstname: 'Nelson',
          lastname: 'Cabral Semedo',
          gender: 'male',
          date_of_birth: '1993-11-16T00:00:00+00:00',
          place_of_birth: 'Lisboa',
          weight: 67,
          height: 177,
          international: true,
          country: {
            id: 'PT',
          },
          slug: 'n-semedo',
        },
        role: {
          titular: false,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18479,
        shirt_number: 3,
        position: {
          id: 2,
          name: 'Defensa',
          slug: 'defensa',
          plural_name: 'Defensas',
          female_name: 'Defensa',
          female_plural_name: 'Defensas',
        },
        person: {
          id: 5,
          name: 'Gerard Piqué Bernabéu',
          nickname: 'Piqué',
          firstname: 'Gerard',
          lastname: 'Piqué Bernabéu',
          gender: 'male',
          date_of_birth: '1987-02-02T00:00:00+00:00',
          place_of_birth: 'Barcelona',
          weight: 85,
          height: 194,
          international: true,
          country: {
            id: 'ES',
          },
          slug: 'pique',
        },
        role: {
          titular: true,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18486,
        shirt_number: 4,
        position: {
          id: 3,
          name: 'Centrocampista',
          slug: 'centrocampista',
          plural_name: 'Centrocampistas',
          female_name: 'Centrocampista',
          female_plural_name: 'Centrocampistas',
        },
        person: {
          id: 137,
          name: 'Ivan Rakitić',
          nickname: 'I. Rakitic',
          firstname: 'Ivan',
          lastname: 'Rakitić',
          gender: 'male',
          date_of_birth: '1988-03-10T00:00:00+00:00',
          place_of_birth: 'Rheinfelden',
          weight: 78,
          height: 184,
          international: true,
          country: {
            id: 'CH',
          },
          slug: 'i-rakitic',
        },
        role: {
          titular: true,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18487,
        shirt_number: 5,
        position: {
          id: 3,
          name: 'Centrocampista',
          slug: 'centrocampista',
          plural_name: 'Centrocampistas',
          female_name: 'Centrocampista',
          female_plural_name: 'Centrocampistas',
        },
        person: {
          id: 16,
          name: 'Sergio Busquets Burgos',
          nickname: 'Sergio',
          firstname: 'Sergio',
          lastname: 'Busquets Burgos',
          gender: 'male',
          date_of_birth: '1988-07-16T00:00:00+00:00',
          place_of_birth: 'Sabadell',
          weight: 76,
          height: 189,
          international: true,
          country: {
            id: 'ES',
          },
          slug: 'sergio',
        },
        role: {
          titular: true,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18480,
        shirt_number: 6,
        position: {
          id: 2,
          name: 'Defensa',
          slug: 'defensa',
          plural_name: 'Defensas',
          female_name: 'Defensa',
          female_plural_name: 'Defensas',
        },
        person: {
          id: 9683,
          name: 'Jean-Clair Todibo',
          nickname: 'Todibo',
          firstname: 'Jean-Clair',
          lastname: 'Todibo',
          gender: 'male',
          date_of_birth: '1999-12-30T00:00:00+00:00',
          place_of_birth: 'Cayenne',
          weight: 81,
          height: 190,
          international: false,
          country: {
            id: 'GF',
          },
          slug: 'todibo',
        },
        role: {
          titular: false,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18489,
        shirt_number: 8,
        position: {
          id: 3,
          name: 'Centrocampista',
          slug: 'centrocampista',
          plural_name: 'Centrocampistas',
          female_name: 'Centrocampista',
          female_plural_name: 'Centrocampistas',
        },
        person: {
          id: 8586,
          name: 'Arthur Henrique Ramos de',
          nickname: 'Arthur',
          firstname: 'Arthur Henrique',
          lastname: 'Ramos de',
          gender: 'male',
          date_of_birth: '1996-08-12T00:00:00+00:00',
          place_of_birth: 'Goiânia',
          weight: 73,
          height: 171,
          international: false,
          country: {
            id: 'BR',
          },
          slug: 'arthur',
        },
        role: {
          titular: true,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18493,
        shirt_number: 9,
        position: {
          id: 4,
          name: 'Delantero',
          slug: 'delantero',
          plural_name: 'Delanteros',
          female_name: 'Delantera',
          female_plural_name: 'Delanteras',
        },
        person: {
          id: 1460,
          name: 'Luis Alberto Suárez Díaz',
          nickname: 'Suárez',
          firstname: 'Luis Alberto',
          lastname: 'Suárez Díaz',
          gender: 'male',
          date_of_birth: '1987-01-24T00:00:00+00:00',
          place_of_birth: 'Salto',
          weight: 86,
          height: 182,
          international: true,
          country: {
            id: 'UY',
          },
          slug: 'suarez',
        },
        role: {
          titular: true,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18494,
        shirt_number: 10,
        position: {
          id: 4,
          name: 'Delantero',
          slug: 'delantero',
          plural_name: 'Delanteros',
          female_name: 'Delantera',
          female_plural_name: 'Delanteras',
        },
        person: {
          id: 23,
          name: 'Lionel Andrés Messi',
          nickname: 'Messi',
          firstname: 'Lionel',
          lastname: 'Andrés Messi',
          gender: 'male',
          date_of_birth: '1987-06-24T00:00:00+00:00',
          place_of_birth: 'Rosario',
          weight: 72,
          height: 170,
          international: true,
          country: {
            id: 'AR',
          },
          slug: 'messi',
        },
        role: {
          titular: true,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18475,
        shirt_number: 13,
        position: {
          id: 1,
          name: 'Portero',
          slug: 'portero',
          plural_name: 'Porteros',
          female_name: 'Portera',
          female_plural_name: 'Porteras',
        },
        person: {
          id: 2681,
          name: 'Norberto Murara Neto',
          nickname: 'Neto',
          firstname: 'Norberto',
          lastname: 'Murara Neto',
          gender: 'male',
          date_of_birth: '1989-07-19T00:00:00+00:00',
          place_of_birth: 'Araxá',
          weight: 84,
          height: 190,
          international: true,
          country: {
            id: 'BR',
          },
          slug: 'neto',
        },
        role: {
          titular: false,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18481,
        shirt_number: 15,
        position: {
          id: 2,
          name: 'Defensa',
          slug: 'defensa',
          plural_name: 'Defensas',
          female_name: 'Defensa',
          female_plural_name: 'Defensas',
        },
        person: {
          id: 5861,
          name: 'Clement Nicolas Laurent Lenglet',
          nickname: 'Lenglet',
          firstname: 'Clement Nicolas',
          lastname: 'Laurent Lenglet',
          gender: 'male',
          date_of_birth: '1995-06-17T00:00:00+00:00',
          place_of_birth: 'Beauvais',
          weight: 81,
          height: 186,
          international: false,
          country: {
            id: 'FR',
          },
          slug: 'lenglet',
        },
        role: {
          titular: true,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 19775,
        shirt_number: 16,
        position: {
          id: 2,
          name: 'Defensa',
          slug: 'defensa',
          plural_name: 'Defensas',
          female_name: 'Defensa',
          female_plural_name: 'Defensas',
        },
        person: {
          id: 8436,
          name: 'Moussa Wagué',
          nickname: 'Moussa Wague',
          firstname: 'Moussa',
          lastname: 'Wagué',
          gender: 'male',
          date_of_birth: '1998-10-04T00:00:00+00:00',
          place_of_birth: 'Bignona',
          weight: 70,
          height: 177,
          international: true,
          country: {
            id: 'SN',
          },
          slug: 'moussa-wague',
        },
        role: {
          titular: false,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 19473,
        shirt_number: 17,
        position: {
          id: 3,
          name: 'Centrocampista',
          slug: 'centrocampista',
          plural_name: 'Centrocampistas',
          female_name: 'Centrocampista',
          female_plural_name: 'Centrocampistas',
        },
        person: {
          id: 699,
          name: 'Antoine Griezmann',
          nickname: 'Griezmann',
          firstname: 'Antoine',
          lastname: 'Griezmann',
          gender: 'male',
          date_of_birth: '1991-03-21T00:00:00+00:00',
          place_of_birth: 'Mâcon',
          weight: 73,
          height: 176,
          international: true,
          country: {
            id: 'FR',
          },
          slug: 'griezmann',
        },
        role: {
          titular: true,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18482,
        shirt_number: 18,
        position: {
          id: 2,
          name: 'Defensa',
          slug: 'defensa',
          plural_name: 'Defensas',
          female_name: 'Defensa',
          female_plural_name: 'Defensas',
        },
        person: {
          id: 8,
          name: 'Jordi Alba Ramos',
          nickname: 'Jordi Alba',
          firstname: 'Jordi',
          lastname: 'Alba Ramos',
          gender: 'male',
          date_of_birth: '1989-03-21T00:00:00+00:00',
          place_of_birth: 'Hospitalet de Llobregat',
          weight: 68,
          height: 170,
          international: true,
          country: {
            id: 'ES',
          },
          slug: 'jordi-alba',
        },
        role: {
          titular: true,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18483,
        shirt_number: 20,
        position: {
          id: 2,
          name: 'Defensa',
          slug: 'defensa',
          plural_name: 'Defensas',
          female_name: 'Defensa',
          female_plural_name: 'Defensas',
        },
        person: {
          id: 21,
          name: 'Sergi Roberto Carnicer',
          nickname: 'S. Roberto',
          firstname: 'Sergi',
          lastname: 'Roberto Carnicer',
          gender: 'male',
          date_of_birth: '1992-02-07T00:00:00+00:00',
          place_of_birth: 'Reus',
          weight: 68,
          height: 178,
          international: true,
          country: {
            id: 'ES',
          },
          slug: 's-roberto',
        },
        role: {
          titular: true,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18485,
        shirt_number: 21,
        position: {
          id: 3,
          name: 'Centrocampista',
          slug: 'centrocampista',
          plural_name: 'Centrocampistas',
          female_name: 'Centrocampista',
          female_plural_name: 'Centrocampistas',
        },
        person: {
          id: 5629,
          name: 'Frenkie de Jong',
          nickname: 'De Jong',
          firstname: 'Frenkie',
          lastname: 'de Jong',
          gender: 'male',
          date_of_birth: '1997-05-12T00:00:00+00:00',
          place_of_birth: 'Arkel',
          weight: 74,
          height: 180,
          international: false,
          country: {
            id: 'NL',
          },
          slug: 'de-jong',
        },
        role: {
          titular: false,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18492,
        shirt_number: 22,
        position: {
          id: 3,
          name: 'Centrocampista',
          slug: 'centrocampista',
          plural_name: 'Centrocampistas',
          female_name: 'Centrocampista',
          female_plural_name: 'Centrocampistas',
        },
        person: {
          id: 3705,
          name: 'Arturo Vidal',
          nickname: 'Vidal',
          firstname: 'Arturo',
          lastname: 'Vidal',
          gender: 'male',
          date_of_birth: '1987-05-22T00:00:00+00:00',
          place_of_birth: 'Santiago de Chile',
          weight: 75,
          height: 180,
          international: true,
          country: {
            id: 'CL',
          },
          slug: 'vidal-1',
        },
        role: {
          titular: false,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 18484,
        shirt_number: 23,
        position: {
          id: 2,
          name: 'Defensa',
          slug: 'defensa',
          plural_name: 'Defensas',
          female_name: 'Defensa',
          female_plural_name: 'Defensas',
        },
        person: {
          id: 2306,
          name: 'Samuel Umtiti',
          nickname: 'Umtiti',
          firstname: 'Samuel',
          lastname: 'Umtiti',
          gender: 'male',
          date_of_birth: '1993-11-14T00:00:00+00:00',
          place_of_birth: 'Yaoundé',
          weight: 75,
          height: 182,
          international: true,
          country: {
            id: 'CM',
          },
          slug: 'umtiti',
        },
        role: {
          titular: false,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 19613,
        shirt_number: 26,
        position: {
          id: 1,
          name: 'Portero',
          slug: 'portero',
          plural_name: 'Porteros',
          female_name: 'Portera',
          female_plural_name: 'Porteras',
        },
        person: {
          id: 9409,
          name: 'Ignacio Peña',
          nickname: 'Iñaki',
          firstname: 'Ignacio',
          lastname: 'Peña',
          gender: 'male',
          date_of_birth: '1999-03-02T00:00:00+00:00',
          place_of_birth: 'Alicante',
          weight: 78,
          height: 184,
          international: false,
          country: {
            id: 'ES',
          },
          slug: 'inaki-1',
        },
        role: {
          titular: false,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
      {
        id: 20046,
        shirt_number: 31,
        position: {
          id: 4,
          name: 'Delantero',
          slug: 'delantero',
          plural_name: 'Delanteros',
          female_name: 'Delantera',
          female_plural_name: 'Delanteras',
        },
        person: {
          id: 12722,
          name: 'Anssumane Fati',
          nickname: 'Ansu Fati',
          firstname: 'Anssumane',
          lastname: 'Fati',
          gender: 'male',
          date_of_birth: '2002-10-31T00:00:00+00:00',
          place_of_birth: 'Bissau',
          weight: 66,
          height: 178,
          international: false,
          country: {
            id: 'GW',
          },
          slug: 'ansu-fati',
        },
        role: {
          titular: false,
        },
        cards: {
          A: 1,
          AA: 2,
          R: 3,
        },
      },
    ],
  },
  match_winner_team: {
    id: 4,
    slug: 'fc-barcelona',
    name: 'Fútbol Club Barcelona',
    nickname: 'FC Barcelona',
    boundname: 'FC Barcelona',
    shortname: 'BAR',
    foundation: '1899-11-29T00:00:00+00:00',
    web: 'http://www.fcbarcelona.es',
    shield: {
      id: 127,
      name: 'Escudo BAR',
      caption: 'Escudo BAR',
      url: 'https://assets.laliga.com/assets/2019/06/07/xlarge/barcelona.png',
      resizes: {
        xsmall:
          'https://assets.laliga.com/assets/2019/06/07/xsmall/barcelona.png',
        small:
          'https://assets.laliga.com/assets/2019/06/07/small/barcelona.png',
        medium:
          'https://assets.laliga.com/assets/2019/06/07/medium/barcelona.png',
        large:
          'https://assets.laliga.com/assets/2019/06/07/large/barcelona.png',
        xlarge:
          'https://assets.laliga.com/assets/2019/06/07/xlarge/barcelona.png',
      },
    },
    competitions: [],
    opta_id: 't178',
    old_hub_id: 4,
  },
  home_formation: 541,
  away_formation: 4231,
  gameweek: {
    id: 1435,
    week: 1,
    name: 'Jornada 11',
    shortname: 'J1',
    date: '2019-10-21T19:00:00+00:00',
  },
  venue: {
    id: 53,
    name: 'Estadio Municipal Butarque',
    latitude: '40.33944',
    longitude: '-3.76275',
    capacity: 12450,
    address: 'C/ Arquitectura, s/n. 28914 Leganés (Madrid)',
    timezone: 'Europe/Madrid',
    city: 'Leganés',
    slug: 'estadio-municipal-butarque',
    opta_id: 'v6791',
    old_hub_id: 54,
    foundation: 1998,
    image:
      'https://assets.laliga.com/assets/2019/10/03/medium/2b7303ff6a9beaf1b4dc88599116df55.png',
  },
  persons_role: [
    {
      person: {
        id: 9834,
        name: 'Santiago Jaime Latre',
        nickname: 'Santiago Jaime Latre',
        firstname: 'Santiago',
        lastname: 'Jaime Latre',
        gender: 'male',
        international: false,
        slug: 'santiago-jaime-latre',
      },
      role: {
        name: 'Árbitro Principal',
        female_name: 'Árbitro Principal',
        slug: 'arbitro-principal',
      },
    },
    {
      person: {
        id: 9844,
        name: 'Mario Melero López',
        nickname: 'Mario Melero López',
        firstname: 'Mario',
        lastname: 'Melero López',
        gender: 'male',
        international: false,
        slug: 'mario-melero-lopez',
      },
      role: {
        name: 'VAR',
        female_name: 'VAR',
        slug: 'var',
      },
    },
    {
      person: {
        id: 10030,
        name: 'Manuel Ángel Torre Cimiano',
        nickname: 'Manuel Ángel Torre Cimiano',
        firstname: 'Manuel Ángel',
        lastname: 'Torre Cimiano',
        gender: 'male',
        international: false,
        slug: 'manuel-angel-torre-cimiano',
      },
      role: {
        name: 'AVAR',
        female_name: 'AVAR',
        slug: 'avar',
      },
    },
  ],
  season: {
    id: 7,
    name: 'Temporada 2019/2020',
    year: 2019,
    slug: 'temporada-2019-2020',
  },
  subscription: {
    id: 82,
    name: 'LaLiga Santander',
    slug: 'laliga-santander-2019',
    teams: [],
    rounds: [],
  },
  opta_id: 'g1074949',
  old_hub_id: 12549,
};
